import React from 'react';
export function TransformationSection() {
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-10" data-id="element-178">
          Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10" data-id="element-179">
          {/* Before Card */}
          <div className="bg-red-50/50 rounded-3xl p-6 sm:p-8 border border-red-100 shadow-lg relative overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-180">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-400" data-id="element-181"></div>
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-2xl mb-6 shadow-sm mx-auto" data-id="element-182">
              ❌
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-red-800 mb-6 text-center" data-id="element-183">
              Antes
            </h3>
            <ul className="space-y-4 text-base sm:text-lg font-medium text-gray-700" data-id="element-184">
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-185">
                <span className="text-red-500 mr-3 text-xl" data-id="element-186">✕</span>Plantas que
                se mueren
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-187">
                <span className="text-red-500 mr-3 text-xl" data-id="element-188">✕</span>Confusión
                constante
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-189">
                <span className="text-red-500 mr-3 text-xl" data-id="element-190">✕</span>Intentos
                fallidos
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-191">
                <span className="text-red-500 mr-3 text-xl" data-id="element-192">✕</span>Frustración
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-193">
                <span className="text-red-500 mr-3 text-xl" data-id="element-194">✕</span>Abandono
              </li>
            </ul>
          </div>

          {/* After Card */}
          <div className="bg-garden-bg rounded-3xl p-6 sm:p-8 border border-garden-medium/30 shadow-xl relative overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-195">
            <div className="absolute top-0 left-0 w-full h-2 bg-garden-medium" data-id="element-196"></div>
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-2xl mb-6 shadow-sm mx-auto" data-id="element-197">
              ✅
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-garden-dark mb-6 text-center" data-id="element-198">
              Después
            </h3>
            <ul className="space-y-4 text-base sm:text-lg font-bold text-garden-dark" data-id="element-199">
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-200">
                <span className="text-garden-medium mr-3 text-xl" data-id="element-201">✓</span>Huerta
                funcionando
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-202">
                <span className="text-garden-medium mr-3 text-xl" data-id="element-203">✓</span>
                Claridad total
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-204">
                <span className="text-garden-medium mr-3 text-xl" data-id="element-205">✓</span>
                Plantas vivas
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-206">
                <span className="text-garden-medium mr-3 text-xl" data-id="element-207">✓</span>
                Confianza
              </li>
              <li className="flex items-center bg-white p-3 rounded-xl shadow-sm" data-id="element-208">
                <span className="text-garden-medium mr-3 text-xl" data-id="element-209">✓</span>
                Disfrute real
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}